import React, { useEffect, useState } from "react";
import { FaWhatsapp } from "react-icons/fa";
import Collapse from "../../components/atoms/colapso";
import Footer from "../../components/organisms/footer";
import NavBar from "../../components/organisms/navbar";
import { FaMapMarkerAlt } from 'react-icons/fa';
//import useAuthenticate from "../../hooks/useAuthenticate";
import {
  Container,
  Content,
  H3,
  H5,
  Location,
  P,
  QRCodeImg,
  Span,
  Title,
  TournamentActions,
  TournamentBanner,
  TournamentContainer,
  TournamentContainerBanner,
  TournamentContent,
  TournamentDescription,
  TournamentEnrollmentLink,
  TournamentEnrollmentLinkEndpage,
  TournamentLink,
  EditalContainer,
  EditalContent,
  EditalTitle
} from "./styles";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import api from "../../services/api";
import Swal from "sweetalert2";
// import tabelaPeso from "../../assets/images/tournaments/toledo-international-open-brazilian-jiu-jitsu-2023/tabepla-de-peso.jpeg";
import tabelaPeso from "../../assets/images/tournaments/copa-mestre-do-acai-kids-de-jiu-jitsu-2025/tabela-copa-mestre-do-acai-kids-de-jiu-jitsu-2025.jpg";
import qrCodecopaAmizadeDeJiuJitsu2024 from "../../assets/images/tournaments/copa-amizade-de-jiu-jitsu-2024/qr-coce--copa-amizade-de-jiu-jitsu-2024.jpg";

//Patrocinio
import torneio from "../../assets/images/sponsors/torneio-facil.png";
import vidaAtiva from "../../assets/images/sponsors/vidaAtivaSuplementos.jpeg";
import centroNeurocirurgia from "../../assets/images/sponsors/centro-de-neurocirurgia-e-coluna.jpeg";
import infonLine from "../../assets/images/sponsors/infonLine.jpeg";
import prefeituraNhamunda from "../../assets/images/sponsors/prefeituraNhamunda.jpeg";



//Apoio
import trevusMartialArts from "../../assets/images/sponsors/trevus-martial-arts.jpg";
import { SponsorContainer, SponsorList } from "src/components/atoms/sponsor-area/styles";
import SponsorButton from "src/components/atoms/sponsor-area";
import useAuthenticate from "../../hooks/useAuthenticate";

const sponsors = [
  /*   { img: vidaAtiva  },
    { img: centroNeurocirurgia },
    { img: prefeituraNhamunda },
    { img: contabilizaAm },  */
    { img: torneio, url: "http://www.torneiofacil.com" }, 
];


const support = [
 
  { img: torneio, url: "http://www.torneiofacil.com" },
];


const dataEvento = "18 de outubro de 2025 "
const horaEvento = "14:00h da tarde"
const tituloEvento = "Copa Mestre do Açaí Kids de Jiu Jitsu 2025"
const localEvento = "Ginásio Danilo Biazus"
const endereçoEvento = "Tv. Alvorada, 2-58 - Alvorada, Francisco Beltrão - PR, CEP 85601-075"
const dataDeEncerramentoIncricao = "16/OUT/2025"
const horaDeEncerramentoIncricao = "23h:59"

const dataDeEncerramentoCorrecao = "16/OUT/2025"
const horaDeEncerramentoCorrecao = "23h:59min"

const dataDeEncerramentoInscricaoLote1 = "30/SET/2025"
const dataDeEncerramentoInscricaoLote2 = "16/OUT/2025"
const dataDeEncerramentoInscricaoLote3 = "15/JUL/2025"


const valorinscricaoCategoriaLote1 = "90,00 (noventa reais)"
const valorinscricaoCategoriaLote2 = "100,00 (cem reais)"
const valorinscricaoCategoriaLote3 = "150,00 (cento e cinquenta reais)"
const valorinscricaoLote1ComboGieNogi = "200,00 (duzentos reais)"
const valorinscricaoLote2ComboGieNogi = "230,00 (duzentos e trinta reais)"
const valorinscricaoLote3ComboGieNogi = "250,00 (duzentos e cinquenta reais)"

const valorinscricaoAbsolutoLoteUnico = "100,00 (cem reais)"
const valorinscricaoAbsolutoLote2 = "75,00 (setenta e cinco reais)"

const dataDeDivulgacaoChaves = "17/OUT/2025"
const horaDeDivulgacaoChaves = "23h:59min"

const instituicaoBancaria = "Bradesco"
const tipoDeChavePix = "Telefone"
const ChavePix = "(92) 99468-5161"
const BeneficiarioDaChavePix = "José Michel Tavares Pio"

const dataDeDivulgacaoCronograma = " "
const horaDeDivulgacaoCCronograma = " "

const contatoWhatsApp = "(92) 99468-5161"
const contatoWhatsAppTorneio = "+55 (11) 94456-3515"

const slugGI = "copa-mestre-do-acai-de-kids-jiu-jitsu-francisco-beltrao-pr-gi";
const slugNOGI = "copa-mestre-do-acai-de-jiu-jitsu-francisco-beltrao-pr-nogi";
const rotaInscriçãoGi = "/enrollment/copa-mestre-do-acai-de-kids-jiu-jitsu-francisco-beltrao-pr-gi";
const rotaChecagemGi = "/check/copa-mestre-do-acai-de-kids-jiu-jitsu-francisco-beltrao-pr-gi/search";
const rotaChecagemNoGi = "/check/copa-mestre-do-acai-de-jiu-jitsu-francisco-beltrao-pr-nogi/search";
//const rotaChavesGI = "#"//"http://www.campeonatofacil.com/eventos/jj/main/mainall.asp?s=3.DB5B8D07&u=teste"
const rotaChavesGi = "/tournament/keys/copa-mestre-do-acai-de-kids-jiu-jitsu-francisco-beltrao-pr-gi";
const rotaChavesNoGi = "/tournament/keys/copa-mestre-do-acai-de-jiu-jitsu-francisco-beltrao-pr-nogi";


const CopaMestreDoAcaiKidsDeJiuJitsu2025: React.FC = () => {

  useEffect(() => {
    // Adiciona cache buster se não estiver presente
    if (!window.location.search.includes("cacheBuster")) {
      const cacheBuster = `cacheBuster=${new Date().getTime()}`;
      const newUrl = `${window.location.pathname}?${cacheBuster}`;
      window.location.replace(newUrl); // Redireciona para a nova URL
    }
  }, []);


  const { authenticated } = useAuthenticate();
  const navigate = useNavigate();
  const [tournamentGI, setTournamentGI] = useState<any>();
  const [tournamentNOGI, setTournamentNOGI] = useState<any>();

  useEffect(() => {
    api.get(`/tournaments/${slugGI}`).then(({ data }) => {
      setTournamentGI(data);
    });

    api.get(`/tournaments/${slugNOGI}`).then(({ data }) => {
      setTournamentNOGI(data);
    });
  }, []);

  const handleToSubscriptionPage = (url: string) => {
    if (tournamentGI!.canSubscribe || tournamentNOGI!.canSubscribe) {
      navigate(url);
      return;
    }

    const msg = "Período de inscrição encerrado.";

    Swal.fire({
      title: 'Atenção!',
      text: msg,
      icon: 'error',
    });

    toast.error(msg);
  }
  return (
    <>
      <NavBar />

      <Container>
        <TournamentContainer
          image={require("../../assets/images/tournaments/copa-mestre-do-acai-kids-de-jiu-jitsu-2025/copa-mestre-do-acai-kids-de-jiu-jitsu-2025.jpeg")}
        >
          <TournamentContainerBanner>
            <TournamentBanner
              image={require("../../assets/images/tournaments/copa-mestre-do-acai-kids-de-jiu-jitsu-2025/copa-mestre-do-acai-kids-de-jiu-jitsu-2025.jpeg")}
            />
          </TournamentContainerBanner>
        </TournamentContainer>
        <TournamentContent>
          <Content>
            <Title>{tituloEvento}</Title>
            <Location>
              <Span>Data: {dataEvento}</Span>
              <Span>Início: {horaEvento}</Span>
              <Span>Local: {localEvento}</Span>
              <Span>Endereço: {endereçoEvento}</Span>
               <Span>
                <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                  <FaMapMarkerAlt style={{ marginRight: '8px', color: "red" }} />
                  <a
                    target={"blank"}
                    style={{ color: "#000", textDecoration: "none", fontWeight: "bold" }}
                    href="https://maps.app.goo.gl/mFPnrXKbiB69FUyB6"
                  >
                    Ver no Google Maps
                  </a>
                </div>
              </Span>  
            </Location>
            <P></P>
            <br />

          </Content>
        </TournamentContent>
        <TournamentDescription>
          <TournamentActions>
            <Content>
              <h1 style={{ textAlign: "center" }}>PATROCINADORES</h1>
              <SponsorContainer>
                <SponsorList>
                  {sponsors && sponsors.map((buttons: any, index: number) => (
                    <SponsorButton
                      key={index} // Adicionei uma chave única para cada botão
                      img={buttons.img}
                      url={buttons.url}
                      hasError={false}
                      error="Este campo é obrigatório"
                      target="_blank" // Adicione este atributo
                    />
                  ))}
                </SponsorList>
              </SponsorContainer>
              <h1 style={{ textAlign: "center" }}>APOIO</h1>
              <SponsorContainer>
                <SponsorList>
                  {support &&
                    support.map((buttons: any) => (
                      <SponsorButton
                        img={buttons.img}
                        url={buttons.url}
                        hasError={false}
                        error="Este campo é obrigatório"
                      />
                    ))}
                </SponsorList>
              </SponsorContainer>
            </Content>

            <Content style={{
              marginTop: '32px'
            }}>

              <EditalContainer>
                <EditalTitle>EDITAL {tituloEvento.toLocaleUpperCase()}</EditalTitle>
                <EditalContent>
                  <Span>
                    A {tituloEvento} é um evento tradicional  que
                      fomenta e incentiva a prática do jiu jitsu na cidade de Francisco Beltrão-PR . As lutas
                      serão GI (com kimono), o evento disponibilizará
                      categorias do Pré-Mirim até o Infanto Juvenil, conforme a tabela de peso
                      deste edital. Os competidores terão a oportunidade de testar suas
                      habilidades em um ambiente controlado e com acompanhamento de
                      profissionais qualificados.
                  </Span>
                  <br />
                  <br />
                  <br />
                </EditalContent>

                <Collapse title="PROTOCOLO DE SEGURANÇA CONTRA COVID-19">
                  <P>
                    Devido a dinâmica da situação atual, estamos avaliando diariamente as
                    recomendações dos Órgãos de Saúde e este protocolo pode ser atualizado a
                    qualquer momento caso novas determinações sejam publicadas.
                  </P>
                  <P>
                    Caso o evento seja cancelado por força maior, todas as inscrições serão
                    automaticamente reembolsadas.
                  </P>
                  <P>
                    A organização não é responsável pelos demais custos dos participantes,
                    tais como transporte e hospedagem.
                  </P>
                  <P>
                    Diretrizes do ginásio: Para a segurança de todos, por favor verifique
                    sua temperatura antes de se dirigir ao evento.{" "}
                  </P>
                  <P>Caso haja qualquer sintoma, procure um médico.</P>{" "}
                  <P>
                    {" "}
                    Caso você se sinta indisposto ou esteve em contato com um paciente
                    diagnosticado com Covid-19, por favor fique em casa e procure seu
                    médico.
                  </P>
                  {/* <P>
                  Todo nosso material será desinfetado antes e durante o evento.
                </P> */}
                </Collapse>
                <Collapse title="PREMIAÇÕES: TROFÉU🏆 +  MEDALHAS🥇">
                    <H3>Academias:</H3>
                    <P>1° lugar: 🏆 Troféu </P>
                    <P>2° lugar: 🏆 Troféu </P>
                    <P>3° lugar: 🏆 Troféu </P>
                    <P>4° lugar: 🏆 Troféu </P>
                    <P>5° lugar: 🏆 Troféu </P>

{/*                     <br />
                    <H3>Absoluto Masculino GI:</H3>
                    <H5>Infanto Juvenil 14 e 15 todos Juntos - (Galo a Leve) </H5>
                    <P>1° lugar: R$200,00 + Medalha🥇</P>
                    <P>2° lugar: medalha🥈</P>
                    <P>3° lugar: medalha🥉</P>
                    <H5>Infanto Juvenil 14 e 15 todos Juntos - (Médio a Pesadíssimo) </H5>
                    <P>1° lugar: R$200,00 + Medalha🥇</P>
                    <P>2° lugar: medalha🥈</P>
                    <P>3° lugar: medalha🥉</P>
                    <H5>Juvenil Branca </H5>
                    <P>1° lugar: R$200,00 + Medalha🥇</P>
                    <P>2° lugar: medalha🥈</P>
                    <P>3° lugar: medalha🥉</P>
                    <H5>Juvenil Graduado </H5>
                    <P>1° lugar: R$200,00 + Medalha🥇</P>
                    <P>2° lugar: medalha🥈</P>
                    <P>3° lugar: medalha🥉</P>
                    <H5>Adulto e Master Branca</H5>
                    <P>1° lugar: R$300,00 + Medalha🥇</P>
                    <P>2° lugar: medalha🥈</P>
                    <P>3° lugar: medalha🥉</P>
                    <H5>Adulto e Master Azul</H5>
                    <P>1° lugar: R$400,00 + Medalha🥇</P>
                    <P>2° lugar: medalha🥈</P>
                    <P>3° lugar: medalha🥉</P>
                    <H5>Adulto e Master Roxa</H5>
                    <P>1° lugar: R$500,00 + Medalha🥇</P>
                    <P>2° lugar: medalha🥈</P>
                    <P>3° lugar: medalha🥉</P>
                    <H5>Adulto e Master Marrom </H5>
                    <P>1° lugar: R$700,00 + Medalha🥇</P>
                    <P>2° lugar:  medalha🥈</P>
                    <P>3° lugar: medalha🥉</P>
                    <H5>Adulto e Master Preta </H5>
                    <P>1° lugar: R$900,00 + Medalha🥇</P>
                    <P>2° lugar: medalha🥈</P>
                    <P>3° lugar: medalha🥉</P>
                   
                    <br />

                    <H3>Absoluto Feminino GI:</H3>
               
                    <H5>Infanto Juvenil 14 e 15 todos Juntos - (Galo a Leve) </H5>
                    <P>1° lugar: R$200,00 + Medalha🥇</P>
                    <P>2° lugar: medalha🥈</P>
                    <P>3° lugar: medalha🥉</P>
                    <H5>Infanto Juvenil 14 e 15 todos Juntos - (Médio a Pesadíssimo) </H5>
                    <P>1° lugar: R$200,00 + Medalha🥇</P>
                    <P>2° lugar: medalha🥈</P>
                    <P>3° lugar: medalha🥉</P>
                    <H5>Juvenil Branca</H5>
                    <P>1° lugar: R$200,00 + Medalha🥇</P>
                    <P>2° lugar: medalha🥈</P>
                    <P>3° lugar: medalha🥉</P>
                    <H5>Juvenil Graduadas</H5>
                    <P>1° lugar: R$200,00 + Medalha🥇</P>
                    <P>2° lugar: medalha🥈</P>
                    <P>3° lugar: medalha🥉</P>
                    <H5>Adulto e Master Branca</H5>
                    <P>1° lugar: R$300,00 + Medalha🥇</P>
                    <P>2° lugar: medalha🥈</P>
                    <P>3° lugar: medalha🥉</P>
                    <H5>Adulto e Master Azul/Roxa (Juntas)</H5>
                    <P>1° lugar: R$600,00 + Medalha🥇</P>
                    <P>2° lugar: medalha🥈</P>
                    <P>3° lugar: medalha🥉</P>
                    <H5>Adulto e Master Marrom/Preta (Juntas)</H5>
                    <P>1° lugar: R$900,00 + Medalha🥇</P>
                    <P>2° lugar: medalha🥈</P>
                    <P>3° lugar: medalha🥉</P>
                    
                    <br />
                    <H3>Absoluto Masculino NOGI:</H3>
                    <H5>Adulto e Master Branca - (Juntos)</H5>
                    <P>1° lugar: R$300,00 + Medalha🥇</P>
                    <P>2° lugar: medalha🥈</P>
                    <P>3° lugar: medalha🥉</P>
                    <H5>Adulto e Master Azul/Roxa - (Juntos)</H5>
                    <P>1° lugar: R$600,00 + Medalha🥇</P>
                    <P>2° lugar: medalha🥈</P>
                    <P>3° lugar: medalha🥉</P>
                    <H5>Adulto e Master Marrom/Preta - (Juntos)</H5>
                    <P>1° lugar: R$700,00 + Medalha🥇</P>
                    <P>2° lugar: medalha🥈</P>
                    <P>3° lugar: medalha🥉</P>
                    <br />
                     <H3>Absoluto Feminino NOGI:</H3>
                    <H5>Adulto e Master Branca - (Juntas)</H5>
                    <P>1° lugar: R$300,00 + Medalha🥇</P>
                    <P>2° lugar: medalha🥈</P>
                    <P>3° lugar: medalha🥉</P>
                    <H5>Adulto e Master Azul/Roxa - (Juntas)</H5>
                    <P>1° lugar: R$600,00 + Medalha🥇</P>
                    <P>2° lugar: medalha🥈</P>
                    <P>3° lugar: medalha🥉</P>
                    <H5>Adulto e Master Marrom/Preta - (Juntas)</H5>
                    <P>1° lugar: R$700,00 + Medalha🥇</P>
                    <P>2° lugar: medalha🥈</P>
                    <P>3° lugar: medalha🥉</P> */}
                    <br /> 
                    <H3>Super Lutas</H3>
                    <P>1° lugar: 🏆 Troféu</P>
              
                    <br />
                    <H3>Demais Categorias</H3>
                    <P>1° lugar: medalha🥇 </P>
                    <P>2° lugar: medalha🥈</P>
                    <P>3° lugar: medalha🥉</P>
                    <br />
                   
                  {/*   <p>
                      Estas premiações só irão valer para os Absolutos GI (COM KIMONO) e NOGI (SEM KIMONO) que tiverem 08 (OITO)
                      ou mais atletas inscritos.
                    </p>
                    <p>
                      Em caso de apenas 08 (OITO) ou menos inscritos no Absoluto, a
                      premiação será 50% do valor total.
                    </p>

                    <P>
                      Para a realização de lutas na categoria absoluto, é exigido um mínimo
                      de 8 atletas inscritos.
                    </P>
                    <p>
                      Mais informações sobre as inscrições para o absoluto está disponível
                      na seção INSCRIÇÕES, parágrafo Inscrição de Absoluto deste edital.
                    </p> */}
                    <br />
                  </Collapse>

                <Collapse title="INSCRIÇÕES">
                  <Span>
                    As inscrições para o evento serão realizadas exclusivamente online, por
                    meio do site www.torneiofacil.com.br
                  </Span>
                  <P>
                    Durante o processo de inscrição, o atleta ou seu responsável legal
                    deverá selecionar corretamente a categoria referente idade que o atleta
                    completará no ano de 2025, bem como sua faixa e peso.
                  </P>
                  <P>
                    A idade de competição do atleta é a idade máxima que ele terá em 2025,
                    conforme regra da CBJJ.
                  </P>
                  <br />
                  <H3>Prazo de Inscrição</H3>
                  <P>
                    O prazo final para inscrições e pagamento será até  {dataDeEncerramentoIncricao}, às
                    {horaDeEncerramentoIncricao}min.
                  </P>
                  <br />
                  <P>As inscrições que não forem pagas serão canceladas.</P>
                  <br />
                  <H3>Correção</H3>
                  <P>
                    A correção da inscrição poderá ser realizada somente após a confirmação
                    do pagamento.
                  </P>
                  <P>
                    Em caso de inscrição equivocada, o atleta ou professor responsável
                    poderá corrigir as informações no site www.torneiofacil.com.br,
                    acessando a opção Meu Perfil em seguida Minhas Inscrições.
                  </P>
                  <P>
                    A correção da inscrição ficará disponivel até o encerramento das
                    inscrições {dataDeEncerramentoCorrecao} as {horaDeEncerramentoCorrecao}.
                  </P>
                  <P>
                    Após prazo para correção das inscrições, não serão aceitas modificações
                    nas inscrições.
                  </P>
                  <P>
                    Os atletas que se inscreverem incorretamente estarão sujeitos a
                    desclassificação <b>sem direito a reembolso.</b>
                  </P>
                  <br />
                  <H3>Prazo de Correção</H3>
                  <P>
                    A correção da inscrição fica disponível após a confirmação do pagamento
                    da mesma.
                  </P>
                  <P>
                    A correção da inscrição ficará disponivel até o encerramento das
                    inscrições {dataDeEncerramentoCorrecao} as {horaDeEncerramentoCorrecao}.
                  </P>
                  <H3>Checagem</H3>
                  <P>
                    O sorteio e divulgação das chaves de lutas será em {dataDeDivulgacaoChaves} até às {horaDeDivulgacaoChaves}.
                  </P>
                  <br />
                 {/*  <H3>Inscrição de Absoluto</H3>
                  <P>
                    Somente atletas inscritos na categoria poderão se increver e participar
                    do absoluto.
                  </P>
                  <P>
                    Os atletas só poderão se inscrever no absoluto referente a categoria da
                    sua inscrição no torneio. Exceção apenas para os master que poderá se
                    inscrever como absoluto adulto.
                  </P> */}
                </Collapse>
                <Collapse title="PESSOAS COM DEFICIÊNCIA (PCD)">
                  <H3>
                    As pessoas com deficiência (PCD) devem informar, no momento da
                    inscrição, sua condição pelo WhatsApp. Caso contrário o atleta será
                    desclassificado sem direito a reembolso.
                  </H3>
               
                  <br />
                </Collapse>

                <Collapse title="VALOR DA INSCRIÇÃO">
                  <Span>
                    As inscrições serão divididas em dois lotes:
                  </Span>
                  <br />
                  <H3>Lote 1- Pagamento até {dataDeEncerramentoInscricaoLote1}</H3>
                  <P>Inscrição categoria R$ {valorinscricaoCategoriaLote1}</P>
                  {/* <P>Inscrição Combo GI+NOGI R$ {valorinscricaoLote1ComboGieNogi}</P> */}
                  <br />
                  <H3>Lote 2- Pagamento até {dataDeEncerramentoInscricaoLote2}</H3>
                  <P>Inscrição categoria R$ {valorinscricaoCategoriaLote2}</P>
                  {/* <P>Inscrição Combo GI+NOGI R$ {valorinscricaoLote2ComboGieNogi}</P> */}
                  <br />
                 {/*  <H3>Lote 1- Pagamento até {dataDeEncerramentoInscricaoLote3}</H3>
                  <P>Inscrição GI ou NOGI categoria R$ {valorinscricaoCategoriaLote3}</P>
                  <P>Inscrição Combo GI+NOGI R$ {valorinscricaoLote3ComboGieNogi}</P>
                  <br /> */}
                  <H3>OBS: PARA CADA INSCRIÇÃO, O ATLETA FICARÁ RESPONSÁVEL PELA DOAÇÃO DE 1 KG DE ALIMENTO NÃO PERECÍVEL</H3>
                  
                  
                </Collapse>
                <Collapse title="PAGAMENTO">
                    <H3>
                      A baixa do pagamento será efetuada de forma automática.
                    </H3>
                    <H3>
                      É necessário completar todas as etapas até finalizar a operação de pagamento.
                    </H3>
                  {/* <QRCodeImg src={qrCodecopaAmizadeDeJiuJitsu2024} alt="qrCode" width={300} />
                  <P>
                    <a
                      target={"blank"}
                      style={{ color: "white" }}
                      href="https://whatsa.me/5592981291027/?t=Ol%C3%A1+Thiago_Dellarmelina%2C+vou+enviar+o+comprovante+de+pagamento+referente+a+inscri%C3%A7%C3%A3o+na+%2ACOPA+ORLEY+LOBATO+DE+JIU+JITSU+2024%2A"
                    >
                      <strong>WhatsApp: +55 (92) 98129-1027 </strong>
                      <FaWhatsapp />
                    </a>
                  </P> */}
                  <p />
                  {/* <QRCodeImg src={qrCodeCopaParana} alt="qrCode" width={300} /> */}
                </Collapse>

                <Collapse title="REEMBOLSO DAS INSCRIÇÕES">
                     <H3>
                     Uma vez PAGA a inscrição, o atleta tem direito ao reembolso nas seguintes situações:
                     </H3>
                     <P>
                     1) Quando o evento é CANCELADO.
                     </P>
                     <P>
                     2) Quando ocorre alteração na DATA do evento.
                     </P>
                     <P>
                     3) Quando altera o LOCAL do evento com distância maior que 20km em relação ao anterior.
                     </P>
                     <P>
                     4) Quando há diminuição da premiação, somente para os atletas impactados.
                     </P>
                     <H3>
                     Obs: Para os 4 casos acima, o prazo máximo para solicitar reembolso será de até 5 dias (corridos)
                      após a divulgação do COMUNICADO no site www.torneiofacil.com.br ou DATA FIM da CHECAGEM GERAL ABERTA ( a data que ocorrer primeiro ).
                     </H3>
                     <P>
                     5) Quando o atleta se lesiona e tenha comprado a GARANTIA CAMPEÃ no ato da inscrição (desde que apresente um laudo médico 
                     comprovando a lesão até SEGUNDA-FEIRA antecedente ao evento, através do Fale Conosco). Neste caso da garantia, o atleta 
                     usufrui do reembolso de 80% do valor pago na inscrição.
                     </P>
                     <P>
                     Em caso de CALAMIDADE PÚBLICA, PANDEMIA, CATÁSTROFE NATURAL e DECRETOS GOVERNAMENTAIS, considerados motivo de FORÇA MAIOR,
                      o atleta NÃO TEM direito ao reembolso. 
                     </P>
                     <P>
                     Para estes casos, a organização oferecerá alternativas para uso do crédito do atleta que não puder comparecer na nova data 
                     do evento, ao invés do reembolso, desde que o atleta nos notifique pelo FALE CONOSCO até SEGUNDA-FEIRA antecedente ao evento).
                     </P>
                     <P>
                     Após os períodos predeterminados, o atleta perderá o direito a reembolso ou crédito.
                     </P>
                     <H3>
                     Além disso, o atleta NÃO tem direito a reembolso de valores quando:
                     </H3>
                     <P>
                     1) Está sozinho na chave de luta.
                     </P>
                     <P>
                     2) Se machuca antes do evento impossibilitando o atleta de participar do mesmo, sem ter adquirido a GARANTIA CAMPEÃ.
                     </P>
                     <P>
                     3) Desistência por qualquer motivo.
                     </P>
                 {/*  <H3>
                    Em caso de reembolso sera cobrado uma taxa de manutenção de 20% do valor total da inscrição.
                    Após o fim do perido de inscrição não será possivel o reembolso das inscrições pagas.
                  </H3> */}


                </Collapse>


                <Collapse title="REGRAS">
                  <Span>
                    Todas as regras para o evento estão devidamente estipuladas e detalhadas neste edital.
                  </Span>
                  <Span>
                    Em casos de omissão de regras no presente edital, as normas a serem observadas serão aquelas estabelecidas pela Confederação
                    Brasileira de Jiu-Jitsu (CBJJ), em conformidade com as diretrizes da CBJJ/IBJJF.
                  </Span>
                  <Span>
                    A tabela de peso por categoria, que estabelece os limites de peso para cada categoria, encontra-se disponível no site oficial do evento,
                    acessível por meio do botão denominado "Tabela de Peso".
                  </Span>
                  <Span>
                    As lutas serão com GI (com kimonos de cores Oficiais pela cbjj branco,
                    azul e preto ) os kimonos devem estar limpos sem rasgos e sem odor .
                  </Span>
                  <Span>
                  Para categoria com 3 lutadores, os atletas farão a melhor de
                  três para definição do campeão, segundo e terceiro lugar
                  conforme regra da CBJJ.
                 </Span>
            {/*       <Span>
                    Para categoria com 3 lutadores, o lutador que ficar sozinho no sorteio da chave estará automaticamente na final.
                    Em caso de WO de um atleta, os dois lutadores restantes na categoria disputarão a final.
                  </Span> */}
                  <Span>
                    A pesagem será realizada no dia do evento. O competidor deverá
                    apresentar documento oficial com foto no momento da pesagem.
                  </Span>
                  <Span>
                    A pesagem dos atletas serão realizadas antes do inicio da categoria.
                  </Span>
                  <Span>
                    Atletas que ultrapasarem o limite de peso da categoria que estiverem
                    inscritos serão automaticamente desclassificados e não poderão lutar o
                    Absoluto.
                  </Span>

                  <Span>
                      Afim de evitar chaves sem lutas o esquema de faixa usado será o seguinte: </Span>
                       <P> Branca; </P>
                       <P> Cinza e Amarela (juntas); </P>
                       <P> Laranja e Verde (juntas); </P>
                       
                 {/*  <Span> Será permitida a inscrição de atletas Juvenil na faixa Verde, porém
                        ele lutará como Juvenil faixa Azul.
                        </Span>        */}

                  <Span>Será realizada apenas uma pesagem oficial por atleta.</Span>
                  <Span>
                    Teremos uma balança para pesagem livre (não oficial) para os atletas.
                  </Span>
                  <Span>Teremos duas balanças para pesagem oficial dos atletas.</Span>
                 {/*  <Span>Teremos 4 (quatro) aréas de lutas</Span>
                  <Span>A Arbitragem será composta pela Equipe da Federação de Arbítrio do Amazonas</Span> */}
                  <Span>
                    Atletas que lutaram em outros eventos com faixa superior não poderão
                    lutar com a faixa abaixo. Se descoberto, o competidor será eliminado do
                    torneio sem direito a reembolso.
                  </Span>
                  <br />
                  <H3>Pontuação por equipe</H3>
                {/*   <H5>Categoria e Absoluto, todas as faixas</H5> */}
                  <P>1° lugar: 9 pontos</P>
                  <P>2° lugar: 3 pontos</P>
                  <P>3° lugar: 1 ponto</P>

                 {/*  <P>
                    A organização do evento irá confeccionar um crachá para disponibilizar a apenas um representante por equipe.
                  </P>
                  <P>
                    O representante que for escolhido a usar o crachá fará todas as funções necessárias sobre sua equipe com  relação ao evento.
                  </P>
                  <P>
                    Só ficará 01 representante de cada equipe para
                    tirar todas as dúvidas e os questionamentos só serão aceito vindo do mesmo.
                  </P>
                  <P>
                    O mesmo representante de cada academia finalista subirá no pódio,
                    podendo ter em suas mão a somente a bandeira da academia que foi inscrita no evento.
                  </P>
                  <P>
                    Crianças até 11 anos, poderão ser acompanhadas em sua área de luta apenas com o representante de sua equipe.
                  </P> */}
                  <P>
                    A contagem dos pontos será realizada de forma geral contabilizando os
                    pontos de todas as faixas.
                  </P>
                  <P>Campeão direto não contam pontos, chaves com apenas um inscrito.</P>
                  <P>
                    Campeão por WO, devido a desistência do oponente, contará pontos desde
                    que na chave tenha mais de um inscrito.
                  </P>
                  <P>
                    Categorias com apenas dois atletas da mesma academia não contam pontos
                    para a disputa por academias.
                  </P>
                  <br />
                  {/* <H3>Para o absoluto:</H3>
                  <P>
                    Não será permitido luta combinada.
                  </P>
                  <P>
                    Não será permitido fechamento dos finalistas.
                  </P>
                  <P>
                    Não será permitido o atleta deixar de fazer o combate, afim de beneficiar o outro atleta.
                  </P>
                  <P>
                    Caso aconteça alguns desses itens acima ,  a organização fica sem a obrigação de fazer a entrega  da premiação  citado nesse edital.
                  </P>
                  <br /> */}
                  <P>
                    O que não estiver neste edital, será acatado o que estiver no livro de
                    regras da CBJJ.
                  </P>
                  <br />
                  <P>
                    <a
                      target={"blank"}
                      href="https://cbjj.com.br/books-videos"
                      style={{ color: "white" }}
                    >
                      <strong>LIVRO DE REGRAS DA CBJJ/IBJJF</strong>
                    </a>
                  </P>
                </Collapse>
                <Collapse title={"CRONOGRAMA" + dataDeDivulgacaoCronograma + " " + horaDeDivulgacaoCCronograma}>
                   {/* (EM BREVE)  */}

                  <Container>
                   <br />
                    <span>CRONOGRAMA COPA MESTRE DO AÇAI KIDS 2025</span>

                    <h5>14h00 Abertura do evento e Hino Nacional</h5>
                    <h5>14h30 - Categorias Pré-Mirim e Mirim A - Todas as Faixas masculino/feminino</h5>
                    <h5>15h00 - Categoria Mirim B - Todas as Faixas masculino/feminino</h5>
                    <h5>15h30 - Infantil A - Todas as Faixas masculino/feminino</h5>
                    <h5>16h00 - Infantil B - Todas as faixas masculino/feminino</h5>
                    <h5>16h30 - Infanto-juvenil Todas as faixas Masculino/Feminino</h5>
                    <h5>17h00 - Super Lutas</h5>

                     {/* 
                    <h5>09:00 - Abertura do evento e Hino Nacional</h5>
                    <h5>09:30 - Todas as Categorias Nogi - Categorias Pré-Mirim e Mirim A - Todas as Faixas masculino/feminino</h5>
                    <h5>10:30 - Categoria Mirim B - Todas as Faixas masculino/feminino</h5>
                    <h5>11:00 - Infantil A - Todas as Faixas masculino/feminino</h5>
                    <h5>11:30 - Infantil B - Todas as faixas masculino/feminino</h5>
                    <h5>12:00 - Infanto-juvenil Todas as faixas Masculino/Feminino</h5>
                    <h5>12:30 - Juvenil - Todas as faixas masculino/feminino</h5>
                    <h5>13:00 - Faixa Branca Adulto masculino/feminino</h5>
                    <h5>13:30 - Faixa Branca Masters masculino/feminino</h5>
                    <h5>14:00 - Faixa Azul Adulto e Master Masculino e Feminino</h5>
                    <h5>14:30 - Faixa Roxa Adulto e Master Masculino e Feminino</h5>
                    <h5>15:00 - Faixas Marrom e Preta Adulto e Master Masculino e Feminino</h5>
                    <h5>15:40 - Início das Inscrições dos Absolutos</h5>
                    <h5>16:00 - Ínicio dos Absolutos</h5>
                    <h5>17:00 - Super Lutas</h5>
                    */}

                    <p><strong>Informações importantes:</strong></p>
                    <ul>
                      <li>As inscrições do Absoluto deverão ser feitas após o término das categorias.</li>
                      {/* <li>Os absolutos serão disputados após o término das suas respectivas categorias.</li> */}
                      <li>O cronograma poderá ser adiantado em até 1 hora ou atrasado em até 10 horas, conforme necessidade operacional do evento.</li>
                      <li>O atleta deverá estar presente no ginásio pelo menos 1 hora antes da sua luta.</li>
                      <li>O atleta que não estiver presente no momento da chamada para a pesagem ou luta será desclassificado por W.O.</li>
                      <li>A pesagem será feita antes da 1ª luta do atleta. Em caso de não bater o peso, o atleta será imediatamente desclassificado.</li>
                      <li>Será verificado também as condições do kimono do atleta antes da luta, podendo ocorrer desclassificação.</li>
                      {/* <li>Todos os atletas devem estar 45 minutos antes do tempo de sua categoria na área de aquecimento, podendo lutar até 30 minutos antes do horário previsto no cronograma.</li> */}
                      <li>Para o que não estiver presente neste edital, seguiremos normas e regras da CBJJ.</li>
                    </ul>
                    <p><strong>Obs.:</strong> Desejamos a todos um excelente campeonato!</p>
                    <br />Ossssssssss 
                  </Container>
                </Collapse>
                <Collapse title="CONTATO">
                  <P>
                    Dúvidas sobre cadastro, inscrição, pagamento, correção, checagem ou
                    sugestão de melhorias entre em contato com a equipe do Torneio Fácil
                    por telefone ou WhatsApp.
                  </P>
                  <P>Melhor horário para atendimento das 18:00h as 23:59h.</P>
                  <a
                    target={"blank"}
                    href="https://whatsa.me/5511944563515/?t=Olá%20Equipe%20Torneio%20Fácil!%0A%0APreciso%20de%20ajuda%20com%20minha%20inscri%C3%A7%C3%A3o%20na%20*COPA%20MESTRE%20DO%20AÇAÍ%20KIDS%20DE%20JIU%20JITSU%202025*"
                  >
                    <strong>Telefone/WhatsApp: {contatoWhatsAppTorneio} </strong>
                    <FaWhatsapp />
                  </a>

                  <br />
                </Collapse>
              </EditalContainer>
            </Content>
            <br />
            <Content>
              {authenticated ? (
                <>
                  {/* <TournamentEnrollmentLinkEndpage to="/enrollment/ii-copa-arena-parintins-de-jiu-jitsu-arena-olimpica-rubens-dos-santos-gi">
                    Inscrição GI
                  </TournamentEnrollmentLinkEndpage>
                  <TournamentEnrollmentLinkEndpage to="/enrollment/ii-copa-arena-parintins-de-jiu-jitsu-arena-olimpica-rubens-dos-santos-nogi">
                    Inscrição NOGI
                  </TournamentEnrollmentLinkEndpage> */}

                  <TournamentEnrollmentLinkEndpage to={""} onClick={() => handleToSubscriptionPage(rotaInscriçãoGi)}>
                    Inscrição
                  </TournamentEnrollmentLinkEndpage>

                  <TournamentEnrollmentLinkEndpage to="/profile/subscription">
                    Correção da Inscrição
                  </TournamentEnrollmentLinkEndpage>
                </>
              ) : (
                <>
                  <TournamentEnrollmentLinkEndpage to="" onClick={() => handleToSubscriptionPage("/login")}>
                    Inscrição
                  </TournamentEnrollmentLinkEndpage>

                  <TournamentEnrollmentLinkEndpage to="/login">
                    Correção da Inscrição
                  </TournamentEnrollmentLinkEndpage>
                </>
              )}
              {/* <TournamentLink href="http://www.campeonatofacil.com/eventos/jj/main/mainall.asp?s=3.767B171E&u=teste" target="_blank">Chaves</TournamentLink> */}
              {/* // /check/16-COPA-PARANA-DE-JIU-JITSU */}

              <TournamentLink
                // target="_blank"
                href={rotaChecagemGi}
              >
                Checagem
              </TournamentLink>

             {/*  <TournamentLink
                // target="_blank"
                href={rotaChecagemNoGi}
              >
                Checagem NOGI
              </TournamentLink> */}

              {/* 
              <TournamentLink
                href="/check/toledo-international-open-brazilian-jiu-jitsu-nogi-2023-ginasio-de-esportes-alcides-pan-toledo-pr/search"
                target="_blank"
              >
                Checagem de atletas NO GI
              </TournamentLink>  */}

              {/* <TournamentLink
                // target="_blank"
                href={rotaChavesGI}
              >
                Chaves GI e NOGI
              </TournamentLink> */}

                     <TournamentLink
                              // target="_blank"
                              href={rotaChavesGi}
                            >
                              Chaves
                            </TournamentLink>
              
                           {/*  <TournamentLink
                              // target="_blank"
                              href={rotaChavesNoGi}
                            >
                              Chaves NOGI
                            </TournamentLink> */}

              {/*               <TournamentLink
                href="http://www.campeonatofacil.com/eventos/jj/main/mainall.asp?s=3.5B5B1C9A&u=teste"
                target="_blank"
              >
                Chaves NO GI
              </TournamentLink> */}

              <TournamentLink target="blank" href={tabelaPeso}>
                Tabela de pesos
              </TournamentLink>
              {/* <TournamentLink href="#">Resultados (EM BREVE)</TournamentLink> */}
            </Content>
          </TournamentActions>
        </TournamentDescription>
      </Container>
      <Footer />
    </>
  );
};

export default CopaMestreDoAcaiKidsDeJiuJitsu2025;
